/**
 * Display name de las plantas Blend para mostrar en la UI.
 *
 * El código `BLEND-1` / `BLEND-2` viene del CSV del dosificador y es el
 * identificador técnico que NO podemos cambiar (lo usan ingesta y todos los
 * joins). Para la UI mostramos el nombre humano del equipo físico.
 *
 * Mapeo confirmado con migración 0009_seed_inicial.sql:
 *   BLEND-1 → serial 200824 → recurso BC EQ-0135 → Concremovil Roja E50
 *   BLEND-2 → serial 211119 → recurso BC EQ-0039 → Concremovil Bianca E50
 *
 * Si en algún momento se agrega una tercera planta o el mapeo cambia, este
 * objeto es el único lugar a tocar.
 */
const NOMBRE_DISPLAY: Record<string, string> = {
  'BLEND-1': 'Roja E50',
  'BLEND-2': 'Bianca E50',
};

/**
 * Devuelve el nombre amigable de una planta a partir de su código técnico.
 * Si el código no está mapeado, devuelve el código original (fallback seguro).
 */
export function nombrePlantaDisplay(codigo: string): string {
  return NOMBRE_DISPLAY[codigo] ?? codigo;
}
